<template>
  <div>
    <hide-at :breakpoints="{small: 767, medium: 768, large: 10024}" breakpoint="mediumAndAbove">
        <div>
            <b-nav id="mobileNavBarDispositivi" class="mobile-sub-nav fixed-top scrollable">
                <div>
                    <b-link href="#" @click="mostraPaginaZone" :class="{current: this.zoneType == '' || this.zoneType == null}">{{$t("navbar.zone")}}</b-link>
                    <b-link v-if="haPermessi()" href="#" @click="mostraPaginaGestioneZone" :class="{current: this.zoneType == 'GestioneZone'}">{{$t("navbar.gestione_zone")}}</b-link>
                </div>
            </b-nav>
        </div>
    </hide-at>
    <show-at :breakpoints="{small: 767, medium: 768, large: 10024}" breakpoint="mediumAndAbove">
      <nav class="pl-3 pt-1 fixed-top navbar-illum">
        <b-button
          :pressed="btn_state_all"
          class="typo-label"
          variant="link"
          @click="mostraPaginaZone"
        >{{$t("navbar.zone")}}</b-button>
        <b-button
          v-if="haPermessi()"
          :pressed="btn_state_gestione"
          class="typo-label"
          variant="link"
          @click="mostraPaginaGestioneZone"
        >{{$t("navbar.gestione_zone")}}</b-button>
      </nav>
    </show-at>
  </div>
  
</template>

<script>
import { mapState } from "vuex";
import {showAt, hideAt} from 'vue-breakpoints'

export default {
  name: "NavBarZone",
  components: {
    showAt,hideAt
  },
  data() {
    return {
      zoneType: ''
    };
  },
  mounted() {
    console.log("navbar zone mounted, route = ", this.$router.currentRoute);
    let routeDevType = this.$router.currentRoute.params.zoneType;
    console.log("zoneTypes=" + this.zoneType+", routeDevType:"+routeDevType)
    if (this.$router.currentRoute.name == 'GestioneZone') {
      this.zoneType = 'GestioneZone';
    } else {
      if (this.zoneType != routeDevType) {
        this.zoneType = routeDevType;
        //this.$forceUpdate();
      }
    }
    
  },
  computed: {
    btn_state_all() {
      return this.zoneType == null || this.zoneType == '';
    },
    btn_state_gestione() {
      if (this.$router.currentRoute.name == "GestioneZone") return true;
      else return false;
    },

  },
  watch: {
    '$route'() {
        // TODO: react to navigation event.
        // params cotains the current route parameters
        console.log("route changed 2!",this.$route.params);
        this.zoneType = this.$route.params["zoneType"];
        this.$forceUpdate();
    },
  },
  methods: {
    haPermessi() {
      return true;
    },
    mostraPaginaZone() {
      this.$router.push({
        name: "Zone",
        params: { pid: this.$store.state.currentPlant.id, zoneType: null }
      });
    },
    mostraPaginaGestioneZone() {
      this.$router.push({
        name: "GestioneZone",
        params: { pid: this.$store.state.currentPlant.id, zoneType: 'GestioneZone' }
      });
    },
  }
};
</script>
